import styled from 'styled-components'
import { Input, Card } from 'antd'
import Color from '../../constants/color.constants'

export const CardLogin = styled.div`
  display: flex;
  justify-content: center;
  min-height: 94vh;
`

export const InputLogin = styled(Input)`
  border-radius: 20px;
  height: 40px;
  border: 1px solid ${Color.primary};
  @media only screen and (min-width: 992px) {
    height: 45px;
  }
`

export const InputPassword = styled(Input.Password)`
  border-radius: 20px;
  height: 40px;
  border: 1px solid ${Color.primary};
  @media only screen and (min-width: 992px) {
    height: 45px;
  }
`

export const CardContainer = styled(Card)`
  // flex-grow: 1;
  text-align: -moz-center;
  text-align: -webkit-center;
  background-color: inherit;
  font-family: 'IBMPlexSansThaiRegular';
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
  height: fit-content;
  align-self: center;
  background-color: white;
  width: 407px;
  border-radius: 8px;

  .ant-form-item-explain.ant-form-item-explain-error {
    color: #ff4d4f;
    margin-top: 8px;
    text-align: left;
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    text-align: -webkit-left;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  .ant-input-affix-wrapper-focused {
    border-color: #40a9ff;
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px #7c7c841f;
    box-shadow: 0 0 0 2px #7c7c841f;
  }

  .ant-form-item-explain,
  .ant-form-item-extra {
    color: #ff4d4f;
    margin-top: 8px;
    text-align: left;
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: 300;
    font-size: 12px !important;
    line-height: 16px;
    text-align: -webkit-left;
    clear: both;
    min-height: 24px;
    padding-top: 0px;
    color: red;
    line-height: 1.5715;
  }
  .ant-card-body .ant-input {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
      inset 0 0 0 100px rgba(255, 255, 255, 1);
    margin-top: 5px;
    -webkit-order-radius: 4px;
    -ms-flex-order-radius: 4px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .ant-layout-footer {
    padding: 24px 50px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background: #f0f2f5;
  }
  .ant-checkbox + span {
    font-size: 16px;
    padding-right: 8px;
    padding-left: 18px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: #127ec3;
    border: 1px solid #127ec3;
    box-sizing: border-box;
    border-radius: 2px;
  }
  .ant-form label {
    float: left;
    padding-top: 3px;
    padding-bottom: 16px;
    font-size: 16px;
  }
  .ant-input-affix-wrapper {
    position: relative;
    height: 40px;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 8px 10px 8px 10px;
    color: #127ec3;
    font-size: 14px;
    line-height: 1.5715;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }

  .ant-input-prefix {
    margin-right: 18px;
    font-size: 18px;
  }

  h1 {
    font-weight: 600;
    font-size: 36px;
    line-height: 54px;
    color: ${Color.blue};
    margin: 0;
    span {
      color: ${Color.secondary};
    }
  }

  p {
    font-size: 18px;
    line-height: 27px;
    color: ${Color.textBlack};
    margin-bottom: 55px;
  }

  .ant-card-head {
    min-height: unset;
    border: unset;
  }

  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-width: 874px;

    .login-label {
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      color: ${Color.secondary};
      padding: 0;
      margin-bottom: 14px;
      text-align: left;
    }

    .ant-form {
      width: 100%;

      .ant-form-item {
        margin-bottom: 15px;
      }
    }

    .ant-input {
      border-radius: 4px;
      font-size: 16px;
      line-height: 24px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 21px;
      display: flex;
      align-items: center;
    }

    .ant-input-password {
      border: 1px solid #dadada;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      .ant-input {
        border: unset;
        box-shadow: unset;
        border-radius: unset;
      }
    }

    .btn {
      min-width: 100%;
      min-height: 48px;
      background: #127ec3;
      border-radius: 8px;
      margin-left: auto;
      display: block;
    }
  }

  @media only screen and (max-width: 992px) {
    flex-grow: 0;
    width: 100%;
    .ant-card-body {
      margin: auto;
      position: relative;

      svg {
        max-width: 97px;
        max-height: 96px;
        margin: 0;
      }

      h1 {
        font-size: 18px;
        line-height: 27px;
      }

      p {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 24px;

        &.login-label {
          font-size: 18px;
          line-height: 27px;
        }
      }

      .ant-form .ant-form-item {
        margin-bottom: 15px;
      }

      .btn {
        min-height: 40px;
        width: 100%;
        span {
          vertical-align: unset;
        }
      }
    }
  }
`

export const ClippathBg = styled.div`
  position: relative;

  svg {
    width: 100%;
    max-height: 122px;
    padding: 0 13%;
    display: none !important;
  }

  &:after {
    display: none;
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #1985c7 0%, #1a68a9 68%);
    clip-path: polygon(0 65%, 0% 100%, 100% 100%);
    bottom: 0;
    left: 0;
    opacity: 0.5;
  }

  @media only screen and (max-width: 992px) {
    padding: 0;
    width: 100%;
    max-width: unset;
    // position: absolute;
  }
`
